import React, { forwardRef } from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

const Zoomable = forwardRef(({ selected, i, children, onZoomStop, disabled }, ref) => {
  return (
    <TransformWrapper ref={ref} initialScale={1} maxScale={4} disabled={disabled}>
      <TransformComponent>{children}</TransformComponent>
    </TransformWrapper>
  )
})

export default Zoomable
